import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import Modal from '../../../Modal'
import Members from '../sideBar/Members'
import * as actions from '../../../../stores/actionsList';
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import SwitchStyle1 from '../../../useful/SwitchButton'
import ButtonAnimated from '../../../buttons/ButtonAnimated'





class GroupInfo extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        fixed: false,
        Members: [
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
        ],

        option: [
            { icon: "/assets/icons/manage-gray.svg", title: "{{lang}}messenger.Manage Group", color: "#444", key: "manage" },
            // { icon: "/assets/icons/leave-red.svg", title: "Leave Group", color: "#E61515", key: "leave" },
        ],
        mediaNum: 0
    }

    componentDidMount = () => {
        let media = this.props.media
        let mediaNum = this.state.mediaNum
        Object.values(media).forEach(el => {
            if (el.length > 0) {
                mediaNum = mediaNum + 1
            }
        });
        this.setState({ mediaNum })
        setTimeout(() => {
            this.setState({ fixed: true })
        }, 100);
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }
    setAction = (key) => {
        console.log('setAction')
        if (key == 'leave') {
            this.leaveGroup(key)
        }
        else if (key == 'manage') {
            this.props.changeStage(key)
        }
    }
    leaveGroup = (type, user) => {

        this.setState({ isLoader: true })
        console.log('===========')
        console.log('user', user)
        console.log('messenger', this.props.messenger)
        let data = {}
        if (type == 'leave') {
            data = { messenger: this.props.messenger._id }
        }
        else {
            data = { hub: user.hub._id, fullname: user.hub.fullname, messenger: this.props.messenger._id }
        }
        data.type = type
        // console.log(data)
        this.props.removeUser(data)
        this.setState({ isLoader: false })
    }
    showLeaveModal() {
        this.leaveModal.showModal()
    }

    hideLeaveModal() {
        this.leaveModal.hideModal()
    }

    render() {
        let type = this.state.type
        return (
            <div className='h-100'>
                <div className='h-100'>
                    <div className='flexcb py-3 px-3' style={{ height: '60px', borderBottom: "1px solid #eee", zIndex: 10 }} ref={el => this.firstCurrentNode = el}>
                        <p className='text-bold text-small' style={{}}>{translate('messenger.Group Info')}</p>
                        {/* <button onClick={() => this.openFirstView()}>
                            <img width={25} src='/assets/icons/more-v-black.svg' />
                        </button> */}
                    </div>
                    <div className='scroll-no-scrollbar' style={{ height: 'calc(100% - 60px)' }}>
                        <div className='flexc px-3 py-2' style={{ borderBottom: "1px solid #eee", }}>
                            <img className='br-50 flexcc' width={50} height={50} style={{ objectFit: "cover" }} src={imageAddress(this.props.messenger?.image, 'group')} />
                            <div className='mld-4'>
                                <p className='font-size-16 weight-600 main-c4' style={{}}>{this.props.messenger?.name}</p>
                                <p className='font-size-12 weight-300 main-c7' style={{}}>{this.props.messenger?.users?.length} {translate('messenger.members')}</p>
                            </div>
                        </div>
                        <div className='flexcb w-100 px-2 py-2' style={{ borderBottom: "1px solid #eee" }}>
                            <div className='flexcb w-100 px-2 py-2 hover-gray br-5'>
                                <div className='flexc'>
                                    <img width={22} className='flexcc' src='/assets/icons/messenger/notification-blue.svg' />
                                    <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Notification')}</p>
                                </div>
                                <button className='flexcc'>
                                    <SwitchStyle1 />
                                </button>
                            </div>
                        </div>
                        <div className='py-2' style={{ borderBottom: "1px solid #eee" }} >
                            {this.state.mediaNum > 0 &&
                                <div className='mx-2 mb-1 px-2 py-2 br-5 hover-gray' >
                                    <button className='flexcb w-100' onClick={() => this.props.changeStage('media')}>
                                        <div className='flexc'>
                                            <img width={22} className='flexcc' src='/assets/icons/messenger/media-blue.svg' />
                                            <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Media')}</p>
                                        </div>
                                        <div className='flexcc'>
                                            <img width={22} src='/assets/icons/arrow-right-blue.svg' className='rtl-button' />
                                        </div>
                                    </button>
                                </div>
                            }
                            <div className='mx-2 mt-1 px-2 py-2 br-5 hover-gray' >
                                <button className='flexcb w-100' onClick={() => this.props.changeStage('manage')}>
                                    <div className='flexc'>
                                        <img width={22} className='flexcc rtl-button' src='/assets/icons/messenger/gearshape-blue.svg' />
                                        <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Manage Group')}</p>
                                    </div>
                                    <div className='flexcc'>
                                        <img width={22} src='/assets/icons/arrow-right-blue.svg' className='rtl-button' />
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div className='px-2 py-4'>
                            <div className='flexcb px-2'>
                                <div className='flexc'>
                                    {/* <img width={22} src='/assets/icons/messenger/members-gray.svg' /> */}
                                    <p className='font-size-14' style={{ color: "#222" }}>{this.props.messenger?.users?.length} {translate('messenger.members')}</p>
                                </div>
                                <button className='hover-gray br-5' onClick={() => this.props.changeStage("add")}>
                                    <img className="flexcc" width={22} src='/assets/icons/plus-blue.svg' />
                                </button>
                            </div>
                            <div className='mt-3'>
                                {/* <button className='flexc w-100 py-2 px-2 br-10 hover-gray' onClick={() => this.props.changeStage("add")}>
                                <img width={30} src='/assets/icons/messenger/add-member-blue.svg' />
                                <div className='flexcb w-100 mld-3'>
                                    <p className='font-size-14 weight-500 main-cb' >Add member</p>
                                    <div className='flexc' >
                                        <button>
                                            <img className='flexcc' width={22} src='/assets/icons/arrow-right-blue.svg' />
                                        </button>
                                    </div>
                                </div>
                            </button> */}
                                {console.log('this.props.messenger.users', this.props.messenger?.users)}
                                {this.props.messenger?.users?.map((prop, index) => {
                                    return (
                                        <div className='flexcb w-100 py-2 px-2 br-10 hover-gray'>
                                            <Members isLoader={this.props.isLoader} myId={this.props.myId} leaveGroup={this.leaveGroup} removeUser={this.props.removeUser} user={prop} messenger={this.props.messenger} data={{ name: prop?.hub.fullname, img: prop?.hub.image }} colors={this.props.colors} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='px-3 pb-3 flexce'>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => { }}
                                title={translate('messenger.Leave Group')}
                                icon='/assets/icons/leave-white.svg'
                                textColor={'#fff'}
                                bg={'#ff3a30'}
                            />
                            {/* <button className='flexcc w-100 py-2 br-10 cancel-btn2'>
                            <img width={24} src='/assets/icons/leave-white.svg' />
                            <p className='mld-3 font-size-14' style={{ color: "#fff" }}>{translate('messenger.Leave Group')}</p>
                        </button> */}
                        </div>
                    </div>
                    {this.state.fixed && (

                        <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={-220} zIndex={10} >
                            <div className='shadow-2 px-3 py-1 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                                {this.state.option.map((prop, index) => {
                                    console.log('option prop is')
                                    return (
                                        <div className='my-2'>
                                            <button className='flexc' onClick={() => this.setAction(prop.key)}>
                                                <img src={prop.icon} />
                                                <p className='mld-3' style={{ color: prop.color }}>{checkTranslation(prop.title)}</p>
                                            </button>
                                        </div>
                                    )
                                })}
                                <button className='flexc' onClick={() => this.showLeaveModal()}>
                                    <img src='/assets/icons/leave-red.svg' />
                                    <p className='mld-3' style={{ color: "#E61515" }}>{translate('messenger.Leave Group')}</p>
                                </button>
                            </div>
                        </FixedView>
                    )}

                    <Modal className="blur-bg-side" ref={el => this.leaveModal = el} maxWidth={700} style={{}}>
                        <div className='flexcc p-4 br-15 flex-column m-5' style={{ backgroundColor: "#fff" }}>
                            <p className='font-size-16 text-center weight-500' style={{ color: "#222" }}>{translate('messenger.Leave Group')}</p>
                            <p className='font-size-10 text-center mt-2' style={{ color: "#777" }}>{translate('messenger.If you leave the group, you will no longer have access to the group')}</p>
                            <div className='mt-3 flexc'>
                                <button className='px-3 py-2 br-5 mx-2 red-box-fill' style={{ width: "120px" }} onClick={() => this.leaveGroup('leave')}>
                                    <p className='font-size-14'>{translate('messenger.Leave')}</p>
                                </button>
                                <button className='px-3 py-2 br-5 mx-2' style={{ backgroundColor: "#eee", width: "120px" }} onClick={() => this.hideLeaveModal()}>
                                    <p className='font-size-14'>{translate('messenger.Cancel')}</p>
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div >
            </div >
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupInfo);

